import { styled } from 'linaria/react';

export const Link = styled.a`
	font-style: normal;
	font-weight: normal;
	font-size: 16px;
	line-height: 24px;
	text-decoration: none;
	cursor: pointer;
	color: var(--primary-color);
`;
